/* eslint-disable @next/next/no-img-element */

import Link from 'next/link';
import { ClubItemFragment } from '@amf/shared/types/graphql';

interface ClubItemProps {
  club: ClubItemFragment;
  prefix: string;
}

function ClubItem({ club, prefix }: ClubItemProps) {
  return (
    <Link href={`${prefix}/${club.id}`}>
      <a className='ClubItem'>
        {club.brandUrl && <img src={club.brandUrl} alt={club.name} className='ClubItem__image' />}
        {!club.brandUrl && <div className='ClubItem__image' />}
        <div className='ClubItem__content'>
          <h3 className='ClubItem__title'>{club.name}</h3>
        </div>
      </a>
    </Link>
  );
}

export default ClubItem;
